const dateFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' });
const dateTimeFormat = new Intl.DateTimeFormat('de-DE', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function formatDate(value: string | Date): string {
  return dateFormat.format(typeof value === 'string' ? new Date(value) : value);
}

export function formatDateTime(value: string | Date): string {
  return dateTimeFormat.format(typeof value === 'string' ? new Date(value) : value);
}

const longDateFormat = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});

/** e.g. "Freitag, 23. Oktober". */
export function formatLongDate(value: string | Date): string {
  return longDateFormat.format(typeof value === 'string' ? new Date(value) : value);
}
